import * as React from 'react';
const EMAIL_REGEX = /([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})/gi;
import { logUsage } from 'owa-analytics';
import {
    MailTipsCategory,
    MailTipsActionType,
    MailTipsType,
    MailtipsActionDatapointName,
} from '../datapoints';

/**
 * Finds email addresses in a message and convert them to mailto links
 */

const convertAddressesToLinks = (message: string = '') => {
    if (!message) {
        return <></>;
    }
    const parts = [];
    let regexResult: RegExpExecArray;
    let lastIndex = 0;
    while ((regexResult = EMAIL_REGEX.exec(message)) !== null) {
        if (regexResult.index > lastIndex) {
            parts.push(message.substring(lastIndex, regexResult.index));
        }
        lastIndex = EMAIL_REGEX.lastIndex;
        parts.push(
            <a
                key={regexResult.index}
                href={`mailto:${regexResult[0]}`}
                onClick={logMailTipsDatapoint}>
                {regexResult[0]}
            </a>
        );
    }
    // Grab any remaining text after the last match.
    if (lastIndex !== message.length) {
        parts.push(message.substring(lastIndex, message.length));
    }
    return <span>{parts}</span>;
};

function logMailTipsDatapoint() {
    // Log datapoint
    logUsage(MailtipsActionDatapointName, [
        MailTipsActionType.EmailClicked,
        MailTipsCategory.OutOfOffice,
        MailTipsType.None,
        -1 /*Count is not valid for this action*/,
    ]);
}

export default convertAddressesToLinks;
